import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

function withWebCam(ComposedComponent) {
    @observer
    class WebCamWrapper extends Component {
        @observable myVideo = null;
        @observable canvas = null;
        @observable videoWidth = 276;
        @observable videoHeight = 155;
        @observable stream = null;


        clearWebCam() {
            if (this.stream) this.stream.getTracks()[0].stop();
        }

        getVideoSize() {
            const cW = this.canvas.width;
            const cH = this.canvas.height;
            const vW = this.myVideo.videoWidth;
            const vH = this.myVideo.videoHeight;
            const deltaW = cW / vW;
            const deltaH = cH / vH;
            if (deltaW > deltaH) {
                return {width: (cH * vW) / vH, height: cH};
            }
            return {width: cW, height: (cW * vH) / vW};
        }

        @action handleSuccess = (stream, canvas, video) => {
            this.stream = stream;
            this.myVideo = video;
            this.canvas = canvas;
            this.ctx = this.canvas.getContext('2d');
        };

        @action snapshot = (onSnapImage) => {
            // Draws current image from the video element into the canvas
            const videoSize = this.getVideoSize();
            const startX = (this.canvas.width / 2) - (videoSize.width / 2);
            const startY = (this.canvas.height / 2) - (videoSize.height / 2);
            this.ctx.drawImage(this.myVideo, startX, startY, videoSize.width, videoSize.height);
            this.canvas.toBlob((blob) => {
                onSnapImage([blob]);
            });
            this.stream.getTracks()[0].stop();
        };

        render() {
            return <ComposedComponent
                {...this.props} snapshot={this.snapshot} videoRef={this.videoRef} videoWidth={this.videoWidth}
                videoHeight={this.videoHeight} canvasRef={this.canvasRef} handleSuccess={this.handleSuccess}
                setWebCamToCanvas={this.setWebCamToCanvas} stream={this.stream} clearWebCam={this.clearWebCam}/>;
        }
    }

    return WebCamWrapper;
}

export default withWebCam;
